<script>
import {h} from 'vue'
import {loadMatcha, matchaSiteKey, matchaUrl} from '@/scripts/matcha'

// Renders the <matcha-widget> web component. A render function on purpose:
// h() with a tag string always creates the element. A template relies on the
// build's isCustomElement option, which production builds lose (Vue CLI runs
// templates through thread-loader, which drops functions from loader
// options); Vue then resolves <matcha-widget> to this very component by name
// and recurses until the tab crashes (tantum October 17, ccp October 19 2026).
export default {
  name: 'MatchaWidget',
  props: {
    modelValue: {type: String, default: ''},
  },
  emits: ['update:modelValue'],
  mounted() {
    if (matchaSiteKey) {
      // Without the script the form still submits; admin2 then refuses the
      // missing token with a message.
      loadMatcha().catch((error) => console.error(error))
    }
  },
  render() {
    if (!matchaSiteKey) return null
    // Starts solving when the form gets focus; a submit waits for the token.
    return h('matcha-widget', {
      class: 'mb-3',
      style: '--matcha-accent: var(--bs-primary)',
      sitekey: matchaSiteKey,
      api: matchaUrl,
      lang: 'de',
      onVerified: (event) => this.$emit('update:modelValue', event.detail.token),
      onExpired: () => this.$emit('update:modelValue', ''),
    })
  },
}
</script>
